import * as THREE from 'three'

let _renderer: THREE.WebGLRenderer | null = null

function getRenderer(): THREE.WebGLRenderer {
  if (!_renderer) {
    _renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true })
    _renderer.setSize(80, 80)
    _renderer.setClearColor(0x000000, 0)
    _renderer.domElement.style.display = 'none'
    document.body.appendChild(_renderer.domElement)
  }
  return _renderer
}

/**
 * 将 THREE.Group 渲染为 80×80 的 base64 PNG 缩略图（等轴正交视角）
 */
export function renderThumbnail(group: THREE.Group): string {
  const renderer = getRenderer()

  // 创建离屏场景
  const scene = new THREE.Scene()
  scene.background = new THREE.Color('#1a2332')

  // 灯光
  const ambient = new THREE.AmbientLight(0xffffff, 0.7)
  scene.add(ambient)
  const dir = new THREE.DirectionalLight(0xffffff, 0.8)
  dir.position.set(5, 8, 5)
  scene.add(dir)

  // 克隆 group 避免影响原始场景
  const clone = group.clone(true)
  scene.add(clone)

  // 计算包围盒，居中并自适应
  const box = new THREE.Box3().setFromObject(clone)
  const center = new THREE.Vector3()
  box.getCenter(center)
  clone.position.sub(center)

  const size = new THREE.Vector3()
  box.getSize(size)
  const maxDim = Math.max(size.x, size.y, size.z)

  // 正交相机
  const half = maxDim * 0.7
  const camera = new THREE.OrthographicCamera(-half, half, half, -half, 0.01, maxDim * 10)
  camera.position.set(maxDim, maxDim * 0.8, -maxDim)
  camera.lookAt(0, 0, 0)

  renderer.render(scene, camera)

  const dataUrl = renderer.domElement.toDataURL('image/png')

  // 清理克隆对象
  scene.remove(clone)
  clone.traverse((obj) => {
    if (obj instanceof THREE.Mesh) {
      obj.geometry.dispose()
    }
  })

  return dataUrl
}

export function disposeThumbnailRenderer() {
  if (_renderer) {
    _renderer.dispose()
    _renderer.domElement.remove()
    _renderer = null
  }
}
